'use strict'


import {ModelBase} from './base'
import {Storage, Folder, File} from './Storage'
import {Probe} from './Probe'
import {Plate} from './Plate'
import {ProbePlex, ProbePlexProbe} from './ProbePlex'
import {Well} from "./Well"
import {HotWell} from './hot'

import {Seq} from './Seq'

export {
	ModelBase,
	Storage, Folder, File,
	Probe, ProbePlex, ProbePlexProbe,
	Plate, Well, HotWell,
	Seq,
}